// extracted by mini-css-extract-plugin
export default {"open":"sidebar-toggle_open__t99if","close":"sidebar-toggle_close__JfOUV","sidebar__toggle":"sidebar-toggle_sidebar__toggle__SMBwm"};